import type { Middleware } from "@reduxjs/toolkit";

import { isAction } from "@reduxjs/toolkit";
import toast from "@v1/components/designSystem/alert/Toast";
import { setStorageItem } from "@v2/hooks/useLocalStorage";

const LAST_NOTIFIED_OF_UPDATES_KEY = "lastNotifiedOfUpdates";

// TODO (gabe 2023-04-21): move to replo-core/constants.ts once it exists
const GIT_SHA_CUSTOM_HEADER_NAME = "X-Git-Sha";

const compareToCurrentShaAndNotify = (serverSha: string | null | undefined) => {
  const currentSha = window.__COMMIT_HASH__;
  if (serverSha && currentSha && currentSha !== serverSha) {
    const lastNotifiedUpdatesValue = localStorage.getItem(
      LAST_NOTIFIED_OF_UPDATES_KEY,
    );
    const lastNotifiedUpdates = lastNotifiedUpdatesValue
      ? new Date(lastNotifiedUpdatesValue)
      : undefined;

    if (
      !lastNotifiedUpdates ||
      lastNotifiedUpdates.getTime() < Date.now() - 1000 * 60 * 60 * 4
    ) {
      toast({
        header: "A new version of Replo is available",
        message: "Please refresh the page to update",
      });
      setStorageItem(LAST_NOTIFIED_OF_UPDATES_KEY, new Date().toISOString());
    }
  }
};

const updateCheckingMiddleware: Middleware = () => (next) => (action) => {
  if (isAction(action) && action.type.endsWith("/fulfilled")) {
    const meta = (
      action as {
        meta?: { baseQueryMeta?: { response?: { headers?: Headers } } };
      }
    ).meta;
    const headers = meta?.baseQueryMeta?.response?.headers;
    const serverSha = headers?.get(GIT_SHA_CUSTOM_HEADER_NAME);
    compareToCurrentShaAndNotify(serverSha);
  }
  return next(action);
};

export default updateCheckingMiddleware;
